import { memo, HTMLAttributes } from "react";
import { useNavigate } from "react-router-dom";
import clsx from "classnames";
import { useStyles } from "./Directory.style";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { PageRoutes } from "../../../constants/historyGaming";
import { useUpdateRecentlyPlayed } from "../../../hooks/useUpdateUserMetadata";
import { GamingStorage } from "../../../models/gamingStorage";
import { DirectoryItem } from "./DirectoryItem";
import { useTranslation } from "react-i18next";
import { FeaturedCard } from "@onmo/graphql/graphql";

interface IServiceItem {
  id: string;
  title: string;
  icon: string;
  link: string;
}

export interface IDirectoryItemProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  items: FeaturedCard[] | IServiceItem[];
  title: string;
}
export interface IActiveIframe {
  feedId: string;
  activeIframe: string;
  background: string;
}

const DirectoryRowComponent: React.FC<
  IDirectoryItemProps & HTMLAttributes<HTMLDivElement>
> = ({ onClick, items, title, ...otherProps }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { updateProducts } = useUpdateRecentlyPlayed();

  const handleActiveIframe = async ({
    feedId,
    activeIframe,
    background,
  }: IActiveIframe) => {
    if (activeIframe.startsWith("/play/")) {
      navigate(activeIframe, { state: { gameImage: background } });
    } else {
      navigate(`${PageRoutes.Feed}?feedId=${feedId}`);
    }
    updateProducts(feedId);
    GamingStorage.setFeedId(feedId);
  };

  if (items.length === 0) return;
  return (
    <div
      {...otherProps}
      className={clsx(classes.rowService, otherProps.className)}
    >
      <Typography variant={TypographyVariant.BodyB3Bold}>
        {t(`directory_${title}`)}
      </Typography>
      <div className={classes.launchpads}>
        {(items as FeaturedCard[]).map((item, idx) => {
          return (
            <DirectoryItem
              key={idx}
              item={item}
              handleActiveIframe={handleActiveIframe}
              isServices={title === "Game Services"}
            />
          );
        })}
      </div>
    </div>
  );
};

export const DirectoryRow = memo(DirectoryRowComponent);
